import type { ComponentPropsWithoutRef, JSX } from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: .5;
    }
`;

const Container = styled.div`
  align-items: center;
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  background-color: ${({ theme }) => theme.color.grey400};
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const MediaSvg = styled.svg`
  color: ${({ theme }) => theme.color.grey300};
  height: 2.5rem;
  width: 2.5rem;
`;

export type MediaPlaceholderProps = ComponentPropsWithoutRef<'div'> & {
  /**
   * Choose which placeholder icon to render
   */
  mediaType: 'image' | 'video';
};

export const MediaPlaceholder = ({
  mediaType,
  ...otherProps
}: MediaPlaceholderProps): JSX.Element => {
  return (
    <Container
      role="status"
      {...otherProps}
    >
      {mediaType === 'image' ? (
        <MediaSvg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 18"
        >
          <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
        </MediaSvg>
      ) : (
        <MediaSvg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 16 20"
        >
          <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
          <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM9 13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2Zm4 .382a1 1 0 0 1-1.447.894L10 13v-2l1.553-1.276a1 1 0 0 1 1.447.894v2.764Z" />
        </MediaSvg>
      )}
    </Container>
  );
};
